import { render, staticRenderFns } from "./HttpStatus.vue?vue&type=template&id=22952921&scoped=true"
import script from "./HttpStatus.vue?vue&type=script&lang=js"
export * from "./HttpStatus.vue?vue&type=script&lang=js"
import style0 from "./HttpStatus.vue?vue&type=style&index=0&id=22952921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22952921",
  null
  
)

export default component.exports